export var ChevronDirection;

(function (ChevronDirection) {
  ChevronDirection["Up"] = "UP";
  ChevronDirection["Down"] = "DOWN";
})(ChevronDirection || (ChevronDirection = {}));